import * as React from "react";
export class Segment extends React.Component {
    render() {
        const { index, time } = this.props;
        return (React.createElement("div", { className: `rj-pulse-bet__progress-period rj-pulse-bet__progress-period-${index}` }, time));
    }
}
//# sourceMappingURL=Segment.js.map